import Vue from 'vue'
import './cube-ui'
import App from './App.vue'
import router from './router/index.js'
import store from './store';
import i18n from './i18n';
import VModal from 'vue-js-modal';
import './webview.js';
// import VConsole from 'vconsole';

Vue.use(VModal);

// var vconsole = new VConsole();
Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
